import { render } from "./NotificationScopes.vue?vue&type=template&id=e1ab9a64"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__